import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "inline-flex justify-content-between align-items-center w-full" }
const _hoisted_2 = ["textContent"]
const _hoisted_3 = { class: "therapy-session-type font-semibold" }

import { toRefs } from 'vue';
import { AttendeeDropdownOptionInterface, AttendeeSessionTypesData, DropdownOptionInterface } from '@/types';
import { EMIT } from '@/enum';
import SelectButton from 'primevue/selectbutton';

interface Props {
  attendee: AttendeeDropdownOptionInterface;
  eventSessionTypes: DropdownOptionInterface[];
  selectedSessionType: AttendeeSessionTypesData;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'GroupSessionTypeSelect',
  props: {
    attendee: {},
    eventSessionTypes: {},
    selectedSessionType: {}
  },
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

const { attendee, selectedSessionType, eventSessionTypes } = toRefs(props);

const checkDisabled = (sessionTypeId: number) => {
  const attendeeSessionType = attendee.value.disciplines[0].treatment_service_type?.id;
  const regularSessionTypeId = eventSessionTypes.value.find((sessionType) => sessionType.name === 'Regular')?.value;
  const makeupSessionTypeId = eventSessionTypes.value.find((sessionType) => sessionType.name === 'Make up')?.value;

  return !(
    attendeeSessionType === sessionTypeId ||
    sessionTypeId === regularSessionTypeId ||
    sessionTypeId === makeupSessionTypeId
  );
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: "text-sm",
      textContent: _toDisplayString(_unref(attendee).name)
    }, null, 8, _hoisted_2),
    _createVNode(_unref(SelectButton), {
      modelValue: _unref(selectedSessionType).therapy_session_type.id,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(selectedSessionType).therapy_session_type.id) = $event)),
      options: _unref(eventSessionTypes),
      "option-disabled": (option) => checkDisabled(option.value),
      "data-key": _unref(selectedSessionType).therapy_session_type.id + _unref(attendee).name,
      "option-label": "acronym",
      "option-value": "value",
      class: "inline-flex gap-2 border-none",
      onChange: _cache[1] || (_cache[1] = ($event: any) => (emit(_unref(EMIT).UPDATE, _unref(selectedSessionType))))
    }, {
      option: _withCtx((slotProps) => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, _toDisplayString(slotProps.option.acronym), 1)
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "options", "option-disabled", "data-key"])
  ]))
}
}

})